import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'
import Card from '../../../components/Card'
import CustomToggle from '../../../components/dropdowns'
import { InView } from "react-intersection-observer";

import { Link, useNavigate, Route } from 'react-router-dom'
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { apiHandler, getApiErrorMessage } from '../../../api/apihandler';
import Swal from 'sweetalert2'
import { INFLUENCERS_LIST, FOLLOW_UNFOLLOW, PEOPLE_YOU_MAY_KNOW, PROFILE_DETAILS, INFLUENCER_POSTED_CHALLENGES } from "../../../api/constants";
import ChallengeCard from '../../../components/challenge/challengeCard'

import LoaderModal from '../../../components/loaderModal'

//profile-header
import ProfileHeader from '../../../components/profile-header'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';
// import state selectors
import { setUserData, setCreatePostType } from '../../../store/setting/actions'

//image
import user1 from '../../../assets/images/user/1.jpg'
import user01 from '../../../assets/images/user/01.jpg'
import user2 from '../../../assets/images/user/02.jpg'
import user3 from '../../../assets/images/user/03.jpg'
import user4 from '../../../assets/images/user/04.jpg'
import img1 from '../../../assets/images/small/07.png'
import img2 from '../../../assets/images/small/08.png'
import img3 from '../../../assets/images/small/09.png'
import img4 from '../../../assets/images/small/10.png'
import img5 from '../../../assets/images/small/11.png'
import img6 from '../../../assets/images/small/12.png'
import img7 from '../../../assets/images/small/13.png'
import img8 from '../../../assets/images/small/14.png'
import p1 from '../../../assets/images/page-img/p1.jpg'
import s4 from '../../../assets/images/page-img/s4.jpg'
import s5 from '../../../assets/images/page-img/s5.jpg'
import p2 from '../../../assets/images/page-img/p2.jpg'
import p3 from '../../../assets/images/page-img/p3.jpg'
import p4 from '../../../assets/images/page-img/p4.jpg'
import p5 from '../../../assets/images/page-img/p5.jpg'
import img42 from '../../../assets/images/page-img/42.png'
import icon1 from '../../../assets/images/icon/01.png'
import icon2 from '../../../assets/images/icon/02.png'
import icon3 from '../../../assets/images/icon/03.png'
import icon4 from '../../../assets/images/icon/04.png'
import icon5 from '../../../assets/images/icon/05.png'
import icon6 from '../../../assets/images/icon/06.png'
import icon7 from '../../../assets/images/icon/07.png'
import img9 from '../../../assets/images/small/img-1.jpg'
import img10 from '../../../assets/images/small/img-2.jpg'
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import CreatePostModal from '../../../components/createPost/createPostModal'
import PeopleYouMayKnowCard from '../../../components/peopleYouMayKnow/peopleYouMayKnowCard'
import StoriesSection from '../../../components/stories/storiesSection'
import NoDataFound from '../../../components/noDataFound'
import CreatePostInputBox from '../../../components/createPost/createPostInputBox'
import MiddleAdCard from '../../../components/ads/middleAdCard'
import RightSideAdsCard from '../../../components/ads/rightSideAdsCard'
import { fetchTranslationLanguages } from '../../../utilities/translationLanguages.js';

const FriendList = () => {
    const navigate = useNavigate();
    const { addToast } = useToasts();
    const [challengesList, setChallengesList] = useState([]);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const dispatch = useDispatch()
    const profileDataRaw = useSelector((state) => state.setting.setting.user_data);
    let profileData = "";
    try {
        profileData = profileDataRaw ? JSON.parse(profileDataRaw) : "";
    } catch (error) {
        profileData = "";
    }

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showLoader, setShowLoader] = useState(false);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [translationLanguages, setTranslationLanguages] = useState([]);

    const [adsPageVal, setAdsPageVal] = useState(1);

    const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

    useEffect(() => {
        //console.log("token",localStorage.getItem("authToken"))
        if (profileData?.user_setting?.is_dance_corner === 1) {
            dispatch(setCreatePostType("2"))
        }
        if (localStorage.getItem("uzoneAuthToken")) {
            setChallengesList([])
            getChallengesList(1)
            getTranslationLanguages()
        } else {
            navigate('/auth/sign-in')
        }
    }, []);

    async function getTranslationLanguages() {
        try {
            const { response: res, languages } = await fetchTranslationLanguages()
            if (res?.data?.response?.status === 200 && Array.isArray(languages)) {
                setTranslationLanguages(languages)
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function updateAdsPageVal(pageVal) {
        setAdsPageVal(pageVal)
    }

    const loadMore = (inView) => {
        if (inView) {
            if (page < maxPage) {
                getChallengesList(page + 1)
                //console.log("scroll working...", page + 1)
                setPage(page + 1)
            }
        }
    };

    function refreshApi() {
        setPage(1)
        setChallengesList([])
        getChallengesList(1)
    }

    async function getChallengesList(pageVal) {
        setShowMoreDataLoader(true)
        //setShowLoader(true)
        try {
            const res = await apiHandler(INFLUENCER_POSTED_CHALLENGES, "POST", {
                page_no: pageVal,
                limit: 3,
                address: "",
                userSlug: "",
                //tagged: "yes",
                hashtag: "",
                type: "2",
                user_id: "",
            })
            if (res.data?.response?.status === 200) {
                setMaxPage(res?.data?.data?.userPosts?.meta?.last_page)
                //console.log("profileRes", maxPage)
                if (res?.data?.data?.userPosts?.meta?.total > 0) {
                    if (pageVal === 1) {
                        setChallengesList(res?.data?.data?.userPosts?.data)
                    } else {
                        setChallengesList(challengesList.concat(res?.data?.data?.userPosts?.data))
                    }
                }
            } else {
                Swal.fire({
                    title: 'Error',
                    text: getApiErrorMessage(res, 'Failed to load challenges. Please try again.'),
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
                navigate('/')
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                //console.log("profileRes",res)
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: 'Error',
                text: getApiErrorMessage(error, 'Failed to load challenges. Please try again.'),
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        finally {
            setShowMoreDataLoader(false)
            //setShowLoader(false)
        }
    }



    return (
        <>
            <LoaderModal showLoader={showLoader} />
            <div id="content-page" className="content-page">
                <Container>
                    <Row>
                        {/* order-2/order-lg-1: on mobile the Stories/People-you-may-know
                            column below shows above this instead of under it;
                            order-lg-1 restores the left position once side by side. */}
                        <Col className="row m-0 p-0 mt-3 mt-lg-0 order-2 order-lg-1">
                            {
                                profileData?.user_setting?.is_dance_corner === 1 ?
                                    <Col sm={12} >
                                        {/* <CreatePostModal
                                            postType={profileData?.user_setting?.is_dance_corner === 1 ? "2" :
                                                profileData?.user_setting?.is_influencer === 1 ? "3" : "4"}
                                            refreshApi={refreshApi}
                                            eventId={""} /> */}
                                        <CreatePostInputBox
                                            postType={profileData?.user_setting?.is_dance_corner === 1 ? "2" :
                                                profileData?.user_setting?.is_influencer === 1 ? "3" : "4"}
                                            refreshApi={refreshApi}
                                            eventId={""} />
                                    </Col> : null
                            }

                            <div>
                                {challengesList?.length > 0 ? challengesList.map((elm, i) => (
                                    <>
                                        <ChallengeCard elm={elm} getChallengeList={refreshApi} key={elm?.id} challengeDetails={false} translationLanguages={translationLanguages} />
                                        {
                                            (i + 1) % 3 === 0 ?
                                                <MiddleAdCard index={i} adsPageVal={adsPageVal} updateAdsPageVal={updateAdsPageVal} /> : null
                                        }
                                    </>

                                )) : <NoDataFound />
                                }
                                {
                                    showMoreDataLoader ?
                                        <div className="col-sm-12 text-center">
                                            <img src={loader} alt="loader" style={{ height: "100px" }} />
                                        </div> : null
                                }
                                <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                            </div>

                        </Col>
                        <Col lg={4} className="order-1 order-lg-2">
                            <StoriesSection isMyStory={false} />
                            <PeopleYouMayKnowCard />
                            <RightSideAdsCard />
                            {/* <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Events</h4>
                                    </div>
                                    <div className="card-header-toolbar d-flex align-items-center">
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                                <i className="ri-more-fill h4"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className=" dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                <Dropdown.Item href="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        <li className="d-flex mb-4 align-items-center ">
                                            <img src={s4} alt="story1" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Web Workshop</h5>
                                                <p className="mb-0">1 hour ago</p>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center">
                                            <img src={s5} alt="story2" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Fun Events and Festivals</h5>
                                                <p className="mb-0">1 hour ago</p>
                                            </div>
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Upcoming Birthday</h4>
                                    </div>
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        <li className="d-flex mb-4 align-items-center">
                                            <img src={user01} alt="story3" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Anna Sthesia</h5>
                                                <p className="mb-0">Today</p>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center">
                                            <img src={user2} alt="story-img" className="rounded-circle img-fluid" />
                                            <div className="stories-data ms-3">
                                                <h5>Paul Molive</h5>
                                                <p className="mb-0">Tomorrow</p>
                                            </div>
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card>
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Suggested Pages</h4>
                                    </div>
                                    <div className="card-header-toolbar d-flex align-items-center">
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle}>
                                                <i className="ri-more-fill h4"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu-right" aria-labelledby="dropdownMenuButton01">
                                                <Dropdown.Item href="#"><i className="ri-eye-fill me-2"></i>View</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-delete-bin-6-fill me-2"></i>Delete</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-pencil-fill me-2"></i>Edit</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-printer-fill me-2"></i>Print</Dropdown.Item>
                                                <Dropdown.Item href="#"><i className="ri-file-download-fill me-2"></i>Download</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <Card.Body>
                                    <ul className="suggested-page-story m-0 p-0 list-inline">
                                        <li className="mb-3">
                                            <div className="d-flex align-items-center mb-3">
                                                <img src={img42} alt="story-img" className="rounded-circle img-fluid avatar-50" />
                                                <div className="stories-data ms-3">
                                                    <h5>Iqonic Studio</h5>
                                                    <p className="mb-0">Lorem Ipsum</p>
                                                </div>
                                            </div>
                                            <img src={img9} className="img-fluid rounded" alt="Responsive" />
                                            <div className="mt-3"><Link to="#" className="btn d-block"><i className="ri-thumb-up-line me-2"></i> Like Page</Link></div>
                                        </li>
                                        <li>
                                            <div className="d-flex align-items-center mb-3">
                                                <img src={img42} alt="story-img" className="rounded-circle img-fluid avatar-50" />
                                                <div className="stories-data ms-3">
                                                    <h5>Cakes & Bakes </h5>
                                                    <p className="mb-0">Lorem Ipsum</p>
                                                </div>
                                            </div>
                                            <img src={img10} className="img-fluid rounded" alt="Responsive" />
                                            <div className="mt-3"><Link to="#" className="btn d-block"><i className="ri-thumb-up-line me-2"></i> Like Page</Link></div>
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )

}

export default FriendList;